import {
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
  Box,
} from "@mui/material";
import "./styles.css";
import KeyboardReturnIcon from "@mui/icons-material/KeyboardReturn";
import LoopOutlinedIcon from "@mui/icons-material/LoopOutlined";

const CustomErrorDialogBox = ({
  header,
  subHeader,
  icon,
  isDialogOpen,
  primaryButtonText,
  secondaryButtonText,
  showPrimaryButton,
  showSecondaryButton,
  onClickPrimaryButton,
  onClickSecondaryButton,
}) => {
  return (
    <Dialog
      className="error-dialog"
      open={isDialogOpen}
      aria-labelledby="delete-audio-title"
    >
      <DialogTitle
        id="delte-audio-dialog-title"
        className="delete-custom-audio-dialog-title"
      >
        {icon}
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          id="save-result-dialog-description"
          className="save-result-dialog-desc"
        >
          <Typography className="error-dialog-box-header">{header}</Typography>
          {subHeader && (
            <Typography className="error-dialog-box-sub-header">
              {subHeader}
            </Typography>
          )}
          {showPrimaryButton && (
            <Box className="custom-primary-button-box">
              <Button
                variant="contained"
                startIcon={<LoopOutlinedIcon className="retake-icon" />}
                className="custom-primary-button-text"
                disableElevation
                onClick={onClickPrimaryButton}
              >
                {primaryButtonText}
              </Button>
            </Box>
          )}
          {showSecondaryButton && (
            <Box className="custom-secondary-button-box">
              <Button
                variant={showPrimaryButton ? "text" : "contained"}
                startIcon={
                  <KeyboardReturnIcon
                    sx={{
                      paddingRight: "2px",
                    }}
                  />
                }
                className="custom-secondary-button-text"
                style={{
                  color: showPrimaryButton ? "#E47714" : "#FFF",
                  background: !showPrimaryButton ? "#E47714" : "#FFF",
                  border: showPrimaryButton && "1px solid #E47714",
                }}
                onClick={onClickSecondaryButton}
                disableElevation
              >
                {secondaryButtonText}
              </Button>
            </Box>
          )}
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

export default CustomErrorDialogBox;
